import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import LineSelect from "../../UI/LineSelect";
import CustomButton from "../../UI/CustomButton/inedx";
import cs from "classnames";
import WelcomeFormStep from "./WelcomeFormStep";
import { useHistory } from "react-router";
import bgImg from "../../../assets/onboardingBg.png";
import { useDispatch, useSelector } from "react-redux";
import {
  onboardingDataSaveAPI,
  setStepsData,
} from "../../../redux/actions/OnboardingAction";
import { onboardingStepsSelector } from "../../../redux/selectors/OnboardingSelectors.ts";
import { toast } from "react-toastify";
import GetUser from "../../../services/get-user";

const QuestionsSteps = () => {
  const [step, setStep] = useState(1);
  const [addGoal, setAddGoal] = useState("");
  const [addpainPoint, setAddPainpoint] = useState("");

  const initialTime = [
    {
      title: "Part-time",
      isSelect: false,
      id: 1,
    },
    {
      title: "Full-time",
      isSelect: true,
      id: 2,
    },
  ];
  const [time, setTime] = useState<any>(initialTime);
  const dispatch = useDispatch();
  const history = useHistory();
  const steps = useSelector(onboardingStepsSelector);
  const handleBack = () => {
    setStep(step - 1);
  };

  const handleNext = () => {
    let isValid = true;
    console.log("steps.platforms", steps.platforms);
    if (
      steps &&
      steps?.platforms?.length > 0 &&
      steps?.platforms.includes("Etsy")
    ) {
      localStorage.setItem("etsyIndicated", "true");
    } else {
      localStorage.removeItem("etsyIndicated");
    }
    switch (step) {
      case 2:
        if (!steps.platforms.length) {
          isValid = false;
          toast("Select platform ", {
            type: "error",
            position: "bottom-left",
            toastId: "Select_platform",
          });
        }
        const findIndex = steps.platforms.findIndex((p) => !p);
        if (findIndex !== -1) {
          isValid = false;
          toast("Type answer ", {
            type: "error",
            position: "bottom-left",
            toastId: "Type_answer",
          });
        }

        break;
      case 3:
        if (!steps.sellerType.length) {
          isValid = false;
          toast("Select seller type ", {
            type: "error",
            position: "bottom-left",
            toastId: "Select_seller_type",
          });
        }
        break;
      case 4:
        if (!steps.profit) {
          isValid = false;
          toast("Select estimate you earn a month ", {
            type: "error",
            position: "bottom-left",
            toastId: "Select_estimate_you",
          });
        }
        break;
      case 5:
        if (!addGoal) {
          toast("Add your Goal!", {
            type: "error",
            position: "bottom-left",
            toastId: "Add_your_Goal!",
          });
          isValid = false;
        }
        if (!steps.goal.length) {
          isValid = false;
          toast("Select your main goal", {
            type: "error",
            position: "bottom-left",
            toastId: "Select_your_main_goal",
          });
        }
        break;
      case 6:
        if (!steps.painpoint.length) {
          isValid = false;
          toast("Select your intend feature", {
            type: "error",
            position: "bottom-left",
            toastId: "Select_your_feature",
          });
        }
        // if (!addpainPoint) {
        //   toast("Add your Pain Point!", {
        //     type: "error",
        //     position: "bottom-left",
        //     toastId: "Add_your_Pain_Point!",
        //   });
        //   isValid = false;
        // }
        // if (!steps.goal.length) {
        //   isValid = false;
        //   toast("Select your main goal", {
        //     type: "error",
        //     position: "bottom-left",
        //     toastId: "Select_your_main_goal",
        //   });
        // }
        break;
    }
    if (!isValid) return;
    if (step === 6) {
      // localStorage.setItem("hintStep", "0");
      const payload = {
        ...GetUser(),
        ...steps,
      };
      dispatch(onboardingDataSaveAPI(payload));
      history.push("/tutorial");
    }
    setStep(step + 1);
  };

  useEffect(() => {
    if (time) {
      const timeType = time?.find((data) => data.isSelect)?.title;
      dispatch(setStepsData({ timeType }));
    }
  }, [time]);

  return (
    <div className="questionsSteps-wrapper">
      <img src={bgImg} className={cs("bg-img", "bg-with-img")} />
      <Row>
        <Col sm={12}>
          <div className="page-center">
            <div
              className={cs(
                "small-wrapper",
                {
                  ["isLarge-wrapper"]: [4, 5].includes(step),
                },
                { ["set-bottom-space"]: step === 2 },
              )}
            >
              {step === 1 ? (
                <div>
                  <div className="title-space">
                    <h1 className="site-title">Welcome to Sotira!</h1>
                    <p className="site-description">
                      Your answers to the next few questions will help us curate
                      the platform for your business needs and goals.
                    </p>
                  </div>
                  <div className="text-center">
                    <h3 className="section-title">
                      Is your business(es) part time or full time?
                    </h3>
                    <div className="select-space d-flex align-items-center mt-5 flex-column text-center">
                      {time.map((data) => (
                        <LineSelect
                          title={data.title}
                          active={data.isSelect}
                          id={data.id}
                          list={time}
                          setList={setTime}
                          isOneSelect
                        />
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <WelcomeFormStep
                  step={step}
                  addGoal={addGoal}
                  setAddGoal={setAddGoal}
                  addpainPoint={addpainPoint}
                  setAddPainpoint={setAddPainpoint}
                />
              )}
              <div className="action-wrapper w-75 mx-auto">
                <div className="d-flex justify-content-between w-100">
                  {step !== 1 ? (
                    <CustomButton secondary size="large" onClick={handleBack}>
                      back
                    </CustomButton>
                  ) : (
                    <div />
                  )}

                  <CustomButton primaryDark size="large" onClick={handleNext}>
                    {step === 6 ? "Done" : "Next"}
                  </CustomButton>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default QuestionsSteps;
